import {Component, OnInit} from '@angular/core';
import {CommonModule} from "@angular/common";
import {IDialogComponent} from "../../../iDialog.component";
import {DialogWithInput} from "../../../dialogWithInput";
import {DialogModule} from "../../../dialog.module";
import {CardModule} from "../../../../../core/component/card/card.module";

export interface HtmlContentDialogInput {
  textAsHtml: string;
}

@Component({
  templateUrl: './html-content-dialog.component.html',
  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    CardModule,
  ]
})
export class HtmlContentDialogComponent implements IDialogComponent<HtmlContentDialogInput, void>{
  dialog: DialogWithInput<HtmlContentDialogInput, void>;
}
